// @flow

import {
  getFormSettings,
} from './main';

import type { State } from '../reducers';

type GlobalState = {
  formSettings: State,
};

type ErrorMessages = $PropertyType<State, 'error_messages'>;

export const getErrorMessages = (state: GlobalState): ErrorMessages => {
  const errorMessages = getFormSettings(state).error_messages;
  if (!errorMessages) {
    throw new Error('Missing errorMessages in formSettings store.');
  }
  return errorMessages;
};

type Required = $PropertyType<ErrorMessages, 'required'>;
export const getRequired = (state: GlobalState): Required => (
  getErrorMessages(state).required
);

type Email = $PropertyType<ErrorMessages, 'email'>;
export const getEmail = (state: GlobalState): Email => (
  getErrorMessages(state).email
);

type NoSelection = $PropertyType<ErrorMessages, 'no_selection'>;
export const getNoSelection = (state: GlobalState): NoSelection => (
  getErrorMessages(state).no_selection
);

type Phone = $PropertyType<ErrorMessages, 'phone'>;
export const getPhone = (state: GlobalState): Phone => (
  getErrorMessages(state).phone
);

type Date = $PropertyType<ErrorMessages, 'date'>;
export const getDate = (state: GlobalState): Date => (
  getErrorMessages(state).date
);

type Equal = $PropertyType<ErrorMessages, 'emails_not_equal'>;
export const getEmailEqual = (state: GlobalState): Equal => (
  getErrorMessages(state).emails_not_equal
);

type Send = $PropertyType<ErrorMessages, 'send_error'>;
export const getNotSend = (state: GlobalState): Send => (
  getErrorMessages(state).send_error
);

export default null;
